// Logged-out pages inside the app shell: no auth, no trial wall. Deliberately
// NOT marketing URLs — signing in there should keep the user on the page.
export const publicPages = ["/pricing", "/contact-sales", "/contact-supplier", "/for-sketchup", "/for-sketchup2"];
export const isPublicPage = (pathname: string) =>
  publicPages.includes(pathname.replace(/\/+$/, ""));

export const marketingUrls = [
  "/",
  "/boards",
  "/brands*",
  "/brand*",
  "/showrooms*",
  "/start_login_ds",
];

// direct returning users to the appropriate page after login
//  IF the user is on a marketing page, check for redirectTo in sessionStorage first
export const authRedirect = (pathname: string): boolean => {
  const isMarketingUrl = marketingUrls.some((url) => {
    if (url.endsWith("*")) {
      // Handle wildcard matching for /brands* to match /brands and /brands/altro
      const prefix = url.slice(0, -1); // Remove the * from the end
      return pathname === prefix || pathname.startsWith(prefix);
    }
    return pathname === url;
  });

  if (isMarketingUrl) {
    // Check for redirectTo in sessionStorage first
    const redirectTo = sessionStorage?.getItem("redirectTo");

    const defaultTarget = "/home/library";

    if (redirectTo) {
      sessionStorage?.removeItem("redirectTo"); // Clean up
      window.location.href = redirectTo;
    } else {
      window.location.href = defaultTarget;
    }
    return true;
  }

  return false;
};
